export default function creatXhr() {
    if (typeof XMLHttpRequest !== 'undefined') {
        return new XMLHttpRequest();
    } else if (typeof ActiveXObject !== 'undefined') {
        if (typeof creatXhr.activeXString !== 'string') {
            const versions = ['MSXML2.XMLHttp.6.0', 'MSXML2.XMLHttp.3.0', 'MSXML2.XMLHttp'];

            for (const key of versions) {
                try {
                    /* eslint-disable no-undef */
                    new ActiveXObject(key);
                    /* eslint-enable no-undef */
                    creatXhr.activeXString = key;
                    break;
                } catch (e) {
                    console.log(e);
                }
            }
        }

        /* eslint-disable no-undef */
        return new ActiveXObject(creatXhr.activeXString);
        /* eslint-enable no-undef */
    } else {
        throw new Error('不支持 XMLHttpRequest');
    }
}
